'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_RecipeSearch(pageIndex, pageSize, textSearch, cuisineSearch, courseSearch, categorySearch, excludeIngredients, maxTotalMinutes, importStates, sort) {
  this.no = 0;
  this.m5 = 0;
  this.oF = null;
  this.oE = null;
  this.oD = null;
  this.nm = null;
  this.q3 = null;
  this.q4 = null;
  this.nn = null;
  this.np = null;
  this.no = pageIndex;
  this.m5 = pageSize;
  this.oF = textSearch;
  this.oE = cuisineSearch;
  this.oD = courseSearch;
  this.nm = categorySearch;
  this.q3 = excludeIngredients;
  this.q4 = maxTotalMinutes;
  this.nn = importStates;
  this.np = sort;
}
export { $c_Lmealorama_RecipeSearch as $c_Lmealorama_RecipeSearch };
$p = $c_Lmealorama_RecipeSearch.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_RecipeSearch;
/** @constructor */
function $h_Lmealorama_RecipeSearch() {
}
export { $h_Lmealorama_RecipeSearch as $h_Lmealorama_RecipeSearch };
$h_Lmealorama_RecipeSearch.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, 1649547510);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, this.no);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, this.m5);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.oF));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.oE));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.oD));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.nm));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.q3));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.q4));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.nn));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.np));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ax(acc, 10);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_RecipeSearch)) {
    if (((this.no === x$0.no) && (this.m5 === x$0.m5))) {
      var x = this.oF;
      var x$2 = x$0.oF;
      var $x_7 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$3 = this.oE;
      var x$4 = x$0.oE;
      var $x_6 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$5 = this.oD;
      var x$6 = x$0.oD;
      var $x_5 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$7 = this.nm;
      var x$8 = x$0.nm;
      var $x_4 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$9 = this.q3;
      var x$10 = x$0.q3;
      var $x_3 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$11 = this.q4;
      var x$12 = x$0.q4;
      var $x_2 = ((x$11 === null) ? (x$12 === null) : x$11.f(x$12));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$13 = this.nn;
      var x$14 = x$0.nn;
      var $x_1 = ((x$13 === null) ? (x$14 === null) : x$13.f(x$14));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$15 = this.np;
      var x$16 = x$0.np;
      return ((x$15 === null) ? (x$16 === null) : x$15.f(x$16));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 10;
});
$p.r = (function() {
  return "RecipeSearch";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.no;
      break;
    }
    case 1: {
      return this.m5;
      break;
    }
    case 2: {
      return this.oF;
      break;
    }
    case 3: {
      return this.oE;
      break;
    }
    case 4: {
      return this.oD;
      break;
    }
    case 5: {
      return this.nm;
      break;
    }
    case 6: {
      return this.q3;
      break;
    }
    case 7: {
      return this.q4;
      break;
    }
    case 8: {
      return this.nn;
      break;
    }
    case 9: {
      return this.np;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_RecipeSearch(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jO)));
}
export { $isArrayOf_Lmealorama_RecipeSearch as $isArrayOf_Lmealorama_RecipeSearch };
var $d_Lmealorama_RecipeSearch = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_RecipeSearch, "mealorama.RecipeSearch", ({
  jO: 1,
  bB: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_RecipeSearch as $d_Lmealorama_RecipeSearch };
//# sourceMappingURL=mealorama.-Recipe-Search.js.map
